import React from 'react';
import block from 'bem-cn-lite';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import SectionList from '../common/SectionList';
import { TextFilterInput } from './../../common/components';
import { queries, CRUD_ROUTE_FILTERED } from './queries';
import I18N from '../../common/i18n';
import { Button } from '../../common/components';
import { 
  Sections, 
  // AppSections 
} from '../../common/enums';
import ImmidiateUploadButton from '../../common/components/ImmidiateUploadButton';
import { importfields as pointFields } from './PointForm';
import { actions as sectionActions} from '../common/actions';
import { store } from '../../..';
import { getSectionLinkBody, getXLSTemplate } from '../../../base/utils';
import icons from '../../common/icons';
import { ITEMS_PER_PAGE } from '..';
import { reducer as authReducer } from '../../auth/actions';
import DropDownContainer from '../../common/components/DropDownContainer';
import { selectActiveFilter } from '../../route_filter/actions';
import { isFilterActive } from '../../route_filter/filterUtils';

const b = block('ListSection');

class PointList extends React.PureComponent {
  static title = I18N.POINTS_LIST_TITLE

  static propTypes = {
    sourceActions: PropTypes.object,
    manifestId: PropTypes.number,
    orgId: PropTypes.number,
    extraReqsFields: PropTypes.arrayOf(PropTypes.object),
    itemElement: PropTypes.func,
    crud: PropTypes.object,
    routeFilter: PropTypes.shape({
      days: PropTypes.arrayOf(PropTypes.number),
      courierIds: PropTypes.arrayOf(PropTypes.number),
    }),
  };

  constructor() {
    super();
    this.state = {titleFilter: ''};
  }

  _applyTitleFilter = (newTitleFilter) => {
    this.setState({titleFilter: newTitleFilter});
  }

  onDeleted = (itemId) => {
    store.dispatch(sectionActions.pointsDeleted([itemId]));
  };

  // With an active route filter (days x couriers) the list is served by a
  // filtered backend op; otherwise the regular section CRUD is used as is.
  _listQueries = () => (isFilterActive(this.props.routeFilter) ? CRUD_ROUTE_FILTERED : this.props.crud);

  _listVariables = () => {
    const variables = {
      'manifest_id': this.props.manifestId || -this.props.orgId,
      'title_filter': this.state.titleFilter,
      'limit': ITEMS_PER_PAGE,
      'offset': 0
    };
    if (!isFilterActive(this.props.routeFilter))
      return variables;
    return {
      ...variables,
      'days': this.props.routeFilter.days,
      'courier_ids': this.props.routeFilter.courierIds,
    };
  }

  render() {
    return (
      <div className={b()}>
        <div className={b('Controls')}>
          <Button
            rightHint={I18N.POINTS_ADD_BASE_BUTTON_HINT}
            to={`${getSectionLinkBody(this.props.manifestId)}${Sections.POINTS}/new/base`}
            className={b('Button')}
          >
            <b>+</b>
            <span>{I18N.POINTS_ADD_BASE_BUTTON}</span>
          </Button>
          <Button
            rightHint={I18N.POINTS_ADD_BUTTON_HINT}
            to={`${getSectionLinkBody(this.props.manifestId)}${Sections.POINTS}/new`}
            className={b('Button')}
          >
            <b>+</b>
            <span>{I18N.POINTS_ADD_BUTTON}</span>
          </Button>
          <ImmidiateUploadButton
            leftHint={I18N.MISC_IMPORT_XLS_HINT}
            fieldsConvert={pointFields}
            sourceActions={this.props.sourceActions}
            section={Sections.POINTS}
            uploadQuery={queries.IMPORT_POINTS} 
            manifestId={this.props.manifestId || -this.props.orgId}
            className={b('Button')}>{I18N.MISC_IMPORT_XLS}</ImmidiateUploadButton>
          <Button
            className={b('Button', { 'Iconed': true })}
            icon={icons.COMMON_XLS_TEMPLATE}
            leftHint={I18N.MISC_DOWNLOAD_XLS_HINT}
            onClick={() => getXLSTemplate(pointFields, this.props.extraReqsFields, I18N.POINTS_TEMPLATE_FILE_NAME)}
          />
          <DropDownContainer>
            <Button
              icon={icons.COMMON_DELETE}
              to={`${getSectionLinkBody(this.props.manifestId)}${Sections.POINTS}/delete`}
            >{I18N.MISC_DELETE_MULTIPLE}</Button>
          </DropDownContainer>
        </div>
        <div className={b('Filters')}>
          <TextFilterInput
            placeHolder={I18N.FILTERS_TITLE}
            onChangeValue={this._applyTitleFilter}
            value={this.state.titleFilter} />
        </div>
        <SectionList
          manifestId={this.props.manifestId || -this.props.orgId}
          queries={this._listQueries()}
          onDeleted={this.onDeleted}
          itemsPerPage={ITEMS_PER_PAGE}
          variables={this._listVariables()}
          itemElement={this.props.itemElement}
        />
      </div>
    );
  }
}

export default
connect(
  (state) => ({
    extraReqsFields: _.get(state, `${authReducer.name}.user.ui_info.extraFields.${Sections.POINTS}.fields`),
    routeFilter: selectActiveFilter(state),
  }),
)(PointList);
